import React, { useState } from 'react';
import "./Accordion.css"
export default function Accordion(){
     const [open, setOpen] = useState(-1);

  const sections = [
    {
      title: "بخش 1: آزمون ناجیگر",
      content: (
        <>
          <h2>محتوای اصلی</h2>

          <h3>شرایط و الزامات شرکت در آزمون ناجیگری:</h3>

          <ul>
            <li>حداقل سن 18 سال تمام</li>
            <li>سلامت کامل جسمی و روانی</li>
            <li>مهارت کافی در شنا</li>
            <li>قبولی در آزمون ورودی</li>
          </ul>
        </>
      ),
    },
    {
      title: "بخش 2: مسیر مربیگری شنا",
      content: (
        <>
        <p>راهنمای گام به گام مربیگری شنا</p>
        <h3>محتوای اصلی</h3>
        <p>شامل مقدمه، دلایل انتخاب مربیگری شنا، مسیر حرفه‌ای (تسلط بر شنا، دوره‌های آموزشی، تجربه عملی، مهارت‌های جانبی)، نکات مهم از خانم زرگران ("صبر، خلاقیت و همدلی")، و فرصت‌های شغلی.</p>
        <p>"تبدیل شدن به یک مربی شنا، یعنی انتقال عشق به آب و مهارت به دیگران." </p>
        </>
      ),
    },
    {
      title: "بخش 3: استخرهای مناسب آموزش شنا در تبریز",
      content:(
        <>
       <p>معرفی استخرهای آموزشی تبریز</p>
        <p>اهمیت انتخاب استخر (ایمنی، تمیزی، عمق، دما، مربی).</p>
                    <h4>معیارهای اصلی انتخاب:</h4>
                    <ul>
                        <li>عمق و بخش‌بندی مناسب</li>
                        <li>ایمنی و نظارت (حضور ناجی غریق)</li>
                        <li>دمای آب و کیفیت آن</li>
                        <li>بهداشت محیط و رختکن‌ها</li>
                        <li>امکانات آموزشی و تجهیزات</li>
                        <li>کیفیت مربیگری و برنامه تمرین</li>
                    </ul>
                    <h4>استخرهای پیشنهادی در تبریز:</h4>
                    <ul>
                        <li><strong>استخر отечество (Patriarch) تبریز:</strong> امکانات خوب و فضای مناسب، کلاس‌های منظم.</li>
                        <li><strong>استخر آب‌درمانی کوثر تبریز:</strong> مناسب برای آموزش، آب‌درمانی و سلامتی.</li>
                        <li><strong>استخرهای مجموعه های ورزشی (مانند پتروشیمی):</strong> استخرهای استاندارد با مربیان باتجربه.</li>
                        <li><strong>استخرهای عمومی سطح شهر:</strong> با بررسی دقیق کیفیت آموزش و ایمنی.</li>
                    </ul>
                    <p>"ایمنی و کیفیت آموزش به اندازه خودِ شنا مهم است." </p>
      </>
      ),
    },
    {
      title:"بخش ۴: بازار کار ناجیگری و مربیگری شنا",
      content:(
        <>
         <h3>چشم‌انداز شغلی و درآمد</h3>
                    <h4>فرصت‌های شغلی ناجیان غریق:</h4>
                    <ul>
                        <li>استخرها (عمومی، خصوصی، هتل‌ها)</li>
                        <li>سواحل دریا و دریاچه</li>
                        <li>پارک‌های آبی</li>
                        <li>باشگاه‌های ورزش‌های آبی</li>
                    </ul>
                    <h4>فرصت‌های شغلی مربیان شنا:</h4>
                    <ul>
                        <li>تدریس در استخرها (گروهی و خصوصی)</li>
                        <li>برگزاری کلاس‌های خصوصی و نیمه خصوصی</li>
                        <li>مربیگری تیم‌های شنا و استعدادیابی</li>
                        <li>کارگاه‌های تخصصی و آب‌درمانی</li>
                    </ul>
                    <p><strong>نکات کلیدی ورود به بازار کار از زبان خانم زرگران:</strong></p>
                    <ul>
                        <li>تجربه عملی و مهارت‌های ارتباطی</li>
                        <li>شبکه‌سازی و ارتباط با فعالان این حوزه</li>
                        <li>یادگیری مداوم و به‌روزرسانی دانش</li>
                        <li>مسئولیت‌پذیری بالا</li>
                    </ul>
                    <p>"این مشاغل می‌توانند پایه‌های یک حرفه موفق و رضایت‌بخش را برای شما بنا نهند."</p>
        </>
      )
    }
  ];

  return (
    <div className="accordion-container">
      {sections.map((item, index) => (
        <div key={index} className="accordion-item">
          <button
            className="accordion-title"
            onClick={() => setOpen(open === index ? -1 : index)}
          >
            <span>{item.title}</span>
            <span>{open === index ? "▲" : "▼"}</span>
          </button>

          {open === index && (
            <div className="accordion-content">
              {item.content}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
